import { ODataSelect } from "@iconics/core";

export class Node extends ODataSelect
{
    public ID = 0;
    public Name = "";
    public Deleted = false;
    public CustomNodeID = "";
    public DisplayName = "";
    public PartitionKey = 0;
    public Parent_ID = 0;
    public HierarchyNodeConfigurationEntityId = 0;
    public FallbackNode_ID = 0;
    public IsEnabled = 0;
    public SortOrder = "";
    public TimeZone = "";
    public TimeZoneType = 0;
    public TimeZoneDST = 0;
    public ImageURI = "";
}

export class OntologyNode extends ODataSelect
{
    public Node_Id = "";
    public OntologyNode_ID = "";
    public Ontology_Name = "";
    public OntologyNode_Name = "";

    override toSelect(): string
    {
        return ''
    }
}

export class OntologyNodeParameter extends ODataSelect
{
    public Id = "";
    public Value = "";
    public ValueType = "";
    public IsEnabled = "";
    public Node_ID = "";
    public Parameter_ID = "";
    public Solution_ID = "";
    public '@odata.etag' = "";

    override toSelect(): string
    {
        return ''
    }
}

export class SolutionParameter extends ODataSelect
{
    public Id = "";
    public Name = "";
    public IsEnabled = "";

    override toSelect(): string
    {
        return ''
    }
}

export class DataPoint extends ODataSelect
{
    public DataPoint_Id = "";
    public Name = "";
    public DisplayName = "";
    public DataPointType = 0;
    public IsEnabled = "";
}

export class Solution extends ODataSelect
{
    public Id = '';
    public Ontology_ID = '';
    public Name = '';
    public DisplayName = '';
    public Description = '';
    public IsEnabled = '';
}

export class Ontology extends ODataSelect
{
    public Id = '';
    public Name = '';
    public DisplayName = '';
    public Description = '';
    public IsEnabled = '';
}

export class OntologyNode2 extends ODataSelect
{
    public Id = '';
    public Name = '';
    public IsEnabled = '';
}
